


// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Mixins } from 'vue-mixin-decorator';

// Third Party
import dayjs, { UnitType } from 'dayjs';
import 'dayjs/locale/es';

// Constants
import Assets from '@/constants/assets.ts';
import Constants from '@/constants/constants.ts';

// Components
import Btn, { BtnColor, BtnWidth, BtnPredefinedStyle } from '@/shared/components/btn.component.vue';
import InlineSpinner, { SpinnerSize } from '@/shared/components/inline-spinner.component.vue';
import Modal, { ModalTitleColor, ModalPredefinedStyle } from '@/shared/components/Modal.component.vue';
import Datepicker, { DatepickerBorder } from '@/shared/components/datepicker/index.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

// Services
import BudgetService from '@/manager/budget/budget.service';

@Component({
    components: {
        Btn,
        Datepicker,
        Icon,
        InlineSpinner,
        Modal,
    },
    computed: {
        ...mapGetters({
        }),
    },
})
export default class GenerateRemittanceModal extends Vue {
    private assets = Assets;
    private iconEnum = IconEnum;
    private modalTitleColor = ModalTitleColor;
    private modalPredefinedStyle = ModalPredefinedStyle;
    private datepickerBorder = DatepickerBorder;
    private spinnerSize = SpinnerSize;
    private btnColor = BtnColor;
    private btnWidth = BtnWidth;
    private btnPredefinedStyle = BtnPredefinedStyle;
    private literals = {
        title: 'Generar remesa',
        subtitle: 'Selecciona la fecha de inicio y de fin en la que se generarán las remesas de los cobros por domiciliación:',
        paymentDate: {
            title: 'Fecha de cobro',
            subtitle: 'Selecciona la fecha en la que se efectuarán los cobros por domiciliación:',
        },
        btn: 'Generar remesa',
        btnDownload: 'Descargar',
        spinner: {
            loading: 'Generando remesa…',
            success: 'Remesa generada',
            error: 'Ha ocurrido un error',
        },
    };
    private remittanceGenerated = false;
    private requestPending = false;
    private serverError = '';
    private dateFrom = '';
    private dateTo = '';
    private paymentDate = '';
    private today = dayjs().toISOString();
    private remmitanceId = '';


    get btnActive() {
        let active = false;
        if ( this.formComplete ) {
            active = true;
        }
        return active;
    }

    get formComplete() {
        return (
            this.dateFrom !== '' &&
            this.dateTo !== '' &&
            this.paymentDate !== ''
        );
    }

    get hasServerError() {
        return this.serverError !== '' && !this.requestPending;
    }

    get isRemittanceGenerated() {
        return this.remittanceGenerated && !this.requestPending;
    }

    get btnText() {
        let text = this.literals.btn;
        if ( this.remittanceGenerated ) {
            text = this.literals.btnDownload;
        }
        return text;
    }


    private closingModal() {
        this.$emit('closing-modal');
    }

    private dateRangeSelected(from: any, to: any) {
        this.dateFrom = from;
        this.dateTo = to;
    }

    private dateSelected(date: any) {
        this.paymentDate = date;
    }

    private btnAction() {
        if ( true || this.formComplete ) {
            if ( this.remittanceGenerated ) {
                this.downloadRemittanceDocument();
            } else {
                this.generateRemittance();
            }
        }
    }

    private setFormError(err: any) {
        this.serverError = this.literals.spinner.error;
        if ( err.response.status === 404 ) {
            this.serverError = err.response.data.detail;
        }
        setTimeout(() => {
            this.serverError = '';
        }, Constants.notificationMessageTimeToAppear);
    }

    private downloadRemittanceDocument() {
        const url = BudgetService.remittanceDocument(this.remmitanceId);
        window.open(url, '_blank');
    }

    private generateRemittance() {
        this.requestPending = true;
        this.serverError = '';
        BudgetService.generateRemittance(this.dateFrom, this.dateTo, this.paymentDate)
            .then(
                (res) => {
                    this.requestPending = false;
                    this.remmitanceId = res.data.id;
                    setTimeout(() => {
                        this.remittanceGenerated = true;
                    }, Constants.notificationMessageTimeToAppear);
                },
                (err) => {
                    this.requestPending = false;
                    setTimeout(() => {
                        this.setFormError(err);
                    }, Constants.notificationMessageTimeToAppear);
                },
            );
    }

}
